import axios from "axios";

import appConfig from "../config/env";

export const WEBSITE_AUTH_STORAGE_KEY = "e-book-webite";

axios.defaults.baseURL = appConfig.apiBaseUrl;
delete axios.defaults.headers.post["Content-Type"];

axios.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem(WEBSITE_AUTH_STORAGE_KEY))?.accessToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

class APIClient {
  get = (url, params) => axios.get(url, { params });

  create = (url, data, headers) => axios.post(url, data, headers);

  update = (url, data, headers) => axios.put(url, data, headers);

  patch = (url, data, headers) => axios.patch(url, data, headers);

  delete = (url, params, headers) => axios.delete(url, { params }, headers);
}

const getLoggedinUser = () => {
  const user = localStorage.getItem(WEBSITE_AUTH_STORAGE_KEY);

  if (!user) {
    return null;
  }

  return JSON.parse(user);
};

export { APIClient, getLoggedinUser };
